import { toaster } from 'components/v2/toast';
import { getEpdWriteBlockedMessage } from 'util/epdActionErrorUtils';
import { QUERY_KEYS } from './constants';
import useOptimisticMutation, { OptimisticMutationConfig } from './useOptimisticMutation';

export default function useCompilerOptimisticMutation<TArgs, TQueryData>(
  config: OptimisticMutationConfig<TArgs, TQueryData>
) {
  const customOnError = config.onError;

  return useOptimisticMutation<TArgs, TQueryData>({
    ...config,
    onAllSettled(callbackArgs) {
      const { queryClient } = callbackArgs;
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.EPD_ACTIONS_STATES] });

      config.onAllSettled?.(callbackArgs);
    },
    // A locked company, a Read-only or a Hidden EPD (409 / 404) always shows the server's message,
    // also when the caller handles other errors itself. Without a custom handler the default toast shows it.
    onError: customOnError
      ? (error, args, context) => {
          const writeBlockedMessage = getEpdWriteBlockedMessage(error);
          if (writeBlockedMessage) {
            toaster({ severity: 'error', summary: 'Error', details: writeBlockedMessage });
            return;
          }

          customOnError(error, args, context);
        }
      : undefined,
  });
}
